import { DegreeTraining, NameSupplies, SuggestionDetails, Users, WorkingDepartment } from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type AccountDeleteTemplate = {
  Users: string;
  NameSupplies: string;
  WorkingDepartment: string;
  SuggestionDetails: string;
  DegreeTraining: string;
};

export const accountDeleteTemplate: TemplatesValue<AccountDeleteTemplate> = {
  fileName: "DanhSachXoaTaiKhoan",
  sheet: DEFAULT_SHEET_NAME,
  structures: [Users, NameSupplies, WorkingDepartment, SuggestionDetails, DegreeTraining],
  fields: ["Users", "NameSupplies", "WorkingDepartment", "SuggestionDetails", "DegreeTraining"],
};
